import React, {Component} from 'react';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";

export default class ReasonForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            code: '',
            trip_type: '',
            text: ''
        };

        if (this.props.item) {
            let reason = this.props.item;
            activeState = {
                id: reason.id,
                text: reason.text,
                trip_type: reason.trip_type,
                code: reason.code
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false
        };
    }

    componentDidMount(){
        window.initializeSelects('.admin-modal');
        window.bindSelectAction(this.tripTypeSelect, this._handleSelectChange);
    }

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['ajaxInProgress', 'id'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});

        if(this.state.id){
            const UPDATE_REASON = `${urls.API_ROOT}/api/v1/rejectionreasons/id/${this.state.id}/`;
            axios.put(`${UPDATE_REASON}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            const NEW_REASON = `${urls.API_ROOT}/api/v1/rejectionreasons/`;
            axios.post(`${NEW_REASON}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Razón de Rechazo ${this.state.id ? 'actualizada' : 'creada'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información de la razón de rechazo',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {
        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de Área' : 'Alta Área'}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.code} type={"text"}
                               onChange={(ev) => this._handleInput('code', ev.target.value)}
                        />
                        <label className="active">Código</label>
                    </div>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.text} type={"text"}
                               onChange={(ev) => this._handleInput('text', ev.target.value)}
                        />
                        <label className="active">Texto</label>
                    </div>
                    <div className={'col s12 input-field'}>
                        <select defaultValue={this.state.trip_type} data-state-var="trip_type"
                                ref={ref => {this.tripTypeSelect = ref}}>
                            <option className="select-option" value="">Seleccione una opción</option>
                            <option className="select-option" value="FE">Fame & Ethanol</option>
                            <option className="select-option" value="INTERN">Cargas Generales</option>
                        </select>
                        <label>Tipo de Viaje</label>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ReasonForm.js